<template>
  <div class="card">
    <DataTable :value="items" class="p-datatable-sm" showGridlines scrollable>
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <Column field="pi_no" header="NO BUKTI" style="min-width: 11rem" />
      <Column field="inv_no" header="No Faktur" style="min-width: 11rem" />
      <Column field="inv_at" header="Tgl Faktur" style="min-width: 5rem">
        <template #body="{ data }">
          {{ formatDate(data.inv_at) }}
        </template>
      </Column>
      <Column field="nama_obat" header="Obat" style="min-width: 13rem" />
      <Column
        field="quantity"
        header="QTY"
        style="min-width: 6.1rem; flex-grow: 1; justify-content: flex-end"
      />
      <Column field="satuan" header="Satuan" style="min-width: 5rem" />
      <Column
        field="harga"
        header="Harga"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.harga, 2, 2) }}
        </template>
      </Column>
      <Column
        field="diskon"
        header="Diskon (%)"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      />
      <Column
        field="diskon_harga"
        header="Diskon (Rp)"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.diskon_harga, 2, 2) }}
        </template>
      </Column>
      <Column
        field="diskon_tambahan"
        header="Diskon Tambahan"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.diskon_tambahan, 2, 2) }}
        </template>
      </Column>
      <Column
        field="jumlah"
        header="Jumlah"
        style="min-width: 9rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah) }}
        </template>
      </Column>
      <!-- {{ formatCurrency((data.harga - data.diskon_harga) * data.quantity) }} -->
      <Column field="batch_no" header="No Batch" style="min-width: 13rem" />
      <Column field="expired_at" header="Tgl. Expire" style="min-width: 5rem">
        <template #body="{ data }">
          {{ formatDate(data.expired_at) }}
        </template>
      </Column>
      <!--
      <Column
        field="ppn"
        header="PPN"
        style="min-width: 6.1rem; flex-grow: 1; justify-content: flex-end"
      />
      <Column
        field="pph"
        header="PPH"
        style="min-width: 6.1rem; flex-grow: 1; justify-content: flex-end"
      />
      -->
      <Column v-if="showButton" style="flex-grow: 1; justify-content: flex-end">
        <template #body="{ data }">
          <Button v-if="status == 'draft'"
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text mr-2"
            @click="$emit('edit', data)"
          />
          <Button v-else
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text mr-2"
            @click="$emit('edit', data)"
            disabled
          />
          <Button v-if="status == 'draft'"
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-danger p-button-text"
            @click="$emit('delete', data)"
          />
          <Button v-else
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-danger p-button-text"
            @click="$emit('delete', data)"
            disabled
          />
        </template>
      </Column>
      <template #footer>
        <table width="340px" class="flex justify-content-end">
          <tr>
            <td width="100%">
              <table class="justify-content-end">
                <tr>
                  <td>SUB TOTAL</td>
                  <td style="width: 150px" class="text-right">
                    {{ formatCurrency(subTotal.subTotal) }}
                  </td>
                </tr>
                <tr>
                  <td>DISKON</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalDiskon) }}
                  </td>
                </tr>
                <tr>
                  <td>DISKON TAMBAHAN&nbsp;</td>
                  <td class="text-right">
                    <!--
                    <InputNumber
                      v-model="nilaiDiskonTambahan"
                      :minFractionDigits="0"
                      :min="0"
                      :disabled="!showButton"
                      mode="currency"
                      currency="IDR"
                      locale="id-ID"
                      @input="updateDiskonTambahan"
                    />
                    -->
                    {{ formatCurrency(subTotal.totalDiskonTambahan, 2, 2) }}
                  </td>
                </tr>
                <tr>
                  <td>{{ format_12 ? 'SUB JUMLAH' : 'DPP' }}</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalDPP, 2, 2) }}
                  </td>
                </tr>
                <tr v-if="format_12">
                  <td>DPP</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalNewDPP, 2, 2) }}
                  </td>
                </tr>
                <tr>
                  <td>PPN</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalPPN, 2, 2) }}
                  </td>
                </tr>
                <tr>
                  <td>PPH 22&nbsp;</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalPPH, 2, 2) }}
                  </td>
                </tr>
                <!--
                <tr>
                  <td>PPH 22&nbsp;</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.totalPPH) }}
                  </td>
                </tr>
                -->
                <!--
                <tr>
                  <td>CN</td>
                  <td class="text-right">
                    <InputNumber
                      v-model="credit"
                      :minFractionDigits="0"
                      :min="0"
                      :disabled="!showButton"
                      mode="currency"
                      currency="IDR"
                      locale="id-ID"
                      @input="updateCN"
                    />
                  </td>
                </tr>
                <tr>
                  <td>DN</td>
                  <td class="text-right">
                    <InputNumber
                      v-model="debit"
                      :minFractionDigits="0"
                      :min="0"
                      :disabled="!showButton"
                      mode="currency"
                      currency="IDR"
                      locale="id-ID"
                      @input="updateDN"
                    />
                  </td>
                </tr>
                -->
                <tr>
                  <td>JUMLAH</td>
                  <td class="text-right">
                    {{ formatCurrency(subTotal.total, 2, 2) }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { formatCurrency, formatDate } from '@/helpers'
import SettingService from '@/services/SettingService'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    diskonTambahan: {
      type: Number,
      default: 0,
    },
    /*
    cn: {
      type: Number,
      default: 0,
    },
    dn: {
      type: Number,
      default: 0,
    },
    */
    status: {
      type: String,
      default: ''
    },
    format_12: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      /* diskonTambahan: 0, */
      nilaiDiskonTambahan: this.diskonTambahan,
      /*
      totalDiskon: 0,
      totalDPP: 0,
      totalPPN: 0,
      total: 0,
      totalPPH: 0,
      */
      ppn: 0,
      /*
      debit: this.dn,
      credit: this.cn,
      */
    }
  },
  mounted() {
    const settingService = new SettingService()
    settingService.get('?filter[key]=PPN').then((res) => {
      this.ppn = res.data.data.value
      /*this.diskonTambahan = this.subTotal.diskonTambahan*/
      /*
      this.totalDPP = this.subTotal.totalDPP
      this.totalPPN = this.jenisHarga === 1 ? 0 : this.subTotal.totalPPN
      this.totalPPH =
        this.pph > 0 ? Math.floor(this.totalDPP * (this.pph / 100)) : 0
      this.total = this.totalDPP + this.totalPPN + this.totalPPH
      */
    })
  },
  /*
  watch: {
    dn(e) {
      this.debit = e
    },
    cn(e) {
      this.credit = e
    },
  },
  */
  computed: {
    subTotal() {
      let res = {}
      const self = this

      //Checked
      const subTotalNett = this.items.reduce(function (total, item) {
        const sub_jumlah = item.harga * item.quantity
        return total + sub_jumlah
      }, 0)

      const totalDiskon = this.items.reduce(function (total, item) {
        const harga_diskon = (item.harga - item.harga_diskon) * item.quantity

        return total + Math.floor(harga_diskon)
      }, 0)

      const totalDiskonTambahan = this.items.reduce(function (total, item) {
        return total + item.diskon_tambahan
      }, 0)

      let totalDPP = this.items.reduce(function (total, item) {
        return (
          total + Math.round((Math.round(item.harga_diskon * item.quantity) - item.diskon_tambahan))
        )
      }, 0)

      let totalNewDPP = this.items.reduce(function (total, item) {
        let dpp = Math.round((Math.round(item.harga_diskon * item.quantity) - item.diskon_tambahan))
        dpp = (item.ppn/12) * dpp
        return (
          total + dpp
        )
      }, 0)
      totalNewDPP = Math.round(totalNewDPP * 100) / 100

      const totalPPN =
        this.items.reduce(function (total, item) {
          const dpp = Math.round((Math.round(item.harga_diskon * item.quantity) - item.diskon_tambahan))
          return (
            total +
            Math.floor(dpp * (item.ppn / 100)
            )
          )
        }, 0) - Math.floor(this.nilaiDiskonTambahan * (self.ppn / 100))

      const totalPPH = this.items.reduce(function (total, item) {
        const dpp = Math.round((Math.round(item.harga_diskon * item.quantity) - item.diskon_tambahan))

        const pph = item.pph ? dpp * (item.pph / 100) : 0
        return total + Math.floor(pph)
      }, 0)

      /*res.diskonTambahan = diskonTambahan ? diskonTambahan : 0*/
      res.subTotal = subTotalNett ? subTotalNett : 0
      res.totalDiskon = totalDiskon ? totalDiskon : 0
      res.totalDiskonTambahan = totalDiskonTambahan ? totalDiskonTambahan : 0
      res.totalDPP = totalDPP ? totalDPP : 0
      res.totalNewDPP = totalNewDPP ? totalNewDPP : 0
      res.totalPPN = totalPPN ? totalPPN : 0
      res.totalPPH = totalPPH ? totalPPH : 0
      res.total =
        (totalDPP ? totalDPP : 0) +
        (totalPPN ? totalPPN : 0) +
        (totalPPH ? totalPPH : 0) // + this.debit - this.credit
      return res
    },
  },
  methods: {
    formatCurrency(value, minDigit = 0, maxDigit = 0) {
      return formatCurrency(value, minDigit, maxDigit)
    },
    formatDate(value) {
      return formatDate(value)
    },
    updateDiskon(e) {
      /*
      this.totalDPP = this.subTotal.totalDPP
      this.totalPPN = this.subTotal.totalPPN
      this.totalPPH =
        this.pph > 0 ? Math.floor(this.totalDPP * (this.pph / 100)) : 0
      this.total = this.totalDPP + this.totalPPN + this.totalPPH - e.value
      */
      this.$emit('diskon', e.value)
    },
    /*
    updateDN(e) {
      const dn = e.value === null ? 0 : e.value
      this.debit = dn
      this.credit = 0
      this.$emit('dn', dn)
      this.$emit('cn', this.credit)
    },
    updateCN(e) {
      const cn = e.value === null ? 0 : e.value
      this.credit = cn
      this.debit = 0
      this.$emit('cn', cn)
      this.$emit('dn', this.debit)
    },
    updateDiskonTambahan(e) {
      this.nilaiDiskonTambahan = e.value === null ? 0 : e.value
      this.$emit('tambahan', this.nilaiDiskonTambahan)
    },
    */
    updatePPH(e) {
      this.$emit('pph', e.value)
    },
  },
}
</script>
